import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../api/api";
import { setLoading } from "../../../app/loadingSlice";

//Call fetch reports ministries mapping list api request
export const fetchReportsMinistriesMappingList = createAsyncThunk("reportsMinistriesMapping/fetchList", async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await get("/ministries/reports")
        return response;
    } catch (error) {
        console.log(error)
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Call map reports and ministries api request
export const mapReportsMinistry = createAsyncThunk("reportsMinistriesMapping/map", async (mapReportsAndMinistry: any, {dispatch}) => {
    dispatch(setLoading(true));
    try {
        const response = await post("/ministries/reports/map", mapReportsAndMinistry);
        return response.data;
    } catch (error) {
        console.log(error)
    }
    finally{
        dispatch(setLoading(false));
    }
});


export const deleteIndicatorsReports = createAsyncThunk(
    "ministries/indicators/delete",
    async (finalObject: object, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await post(`/ministries/reports/delete`, finalObject);
            return response.data;
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(setLoading(false));
        }
        dispatch(setLoading(false));

    }
);
